import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { useStore } from 'vuex';
import { AppStore } from '@/store';
import { Flash } from '@/core/Flash';
import UserForm from '@/modules/user/components/UserForm.vue';
import { User } from '@/modules/user/User';
import { useCustomerRouteLoader } from '@/modules/customer/pages/userCommon';
import { Customer } from '@/modules/customer/Customer';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserCreate',
  setup(__props) {

const { $gettext, interpolate } = useGettext();
const resource = ref();
const customer = ref<Customer>();
const pageTitle = computed(() => interpolate(
	$gettext('Ny användare för %{ name }'),
	{name: customer.value?.name || ''},
));
const router = useRouter();
const store = useStore<AppStore>();

useCustomerRouteLoader(resource, customer);

const user = ref<Partial<User>>({
	type: 'CUSTOMER',
	permissions: [],
	language: store.getters.userLanguage,
});

const saved = (user) => {
	Flash.success($gettext('Användare tillagd'));
	router.push({
		name: 'customer.user.edit',
		params: { id: user.id },
	});
};

const cancel = () => {
	router.push({ name: 'customer.user.index' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserForm, {
    resource: resource.value,
    "page-title": pageTitle.value,
    user: user.value,
    onSaved: saved,
    onCancel: cancel
  }, null, 8, ["resource", "page-title", "user"]))
}
}

})